// extracted by mini-css-extract-plugin
module.exports = {"globalSpin":"index_globalSpin-3TVVs"};